import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const MealIcon = ({ mealType, classObject }) => {
    const iconPath = `/assets/images/icons/meal_${mealType}.svg`;
    return React.createElement("img", { className: css(styles.container, classObject), src: iconPath });
};
const styles = StyleSheet.create({
    container: {
        flexShrink: 0,
        width: 30,
        height: 30,
    },
});
